var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5314 7.49995V10.8333M10.5314 14.1666H10.5397M9.37747 3.24305L2.5234 15.0819C2.14323 15.7386 1.95314 16.0669 1.98124 16.3364C2.00574 16.5714 2.12888 16.785 2.32001 16.924C2.53915 17.0833 2.91853 17.0833 3.6773 17.0833H17.3854C18.1442 17.0833 18.5236 17.0833 18.7427 16.924C18.9339 16.785 19.057 16.5714 19.0815 16.3364C19.1096 16.0669 18.9195 15.7386 18.5393 15.0819L11.6853 3.24305C11.3065 2.58875 11.1171 2.26159 10.87 2.15172C10.6544 2.05587 10.4083 2.05587 10.1928 2.15172C9.94568 2.26159 9.75628 2.58875 9.37747 3.24305Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport4);
export default __webpack_public_path__ + "static/media/report (4).e6314d103414b6a20dbe7c5de5351cfb.svg";
export { ForwardRef as ReactComponent };